function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameMinimapTemplate = require('./game-minimap.template');
var GameZoom = require('../game-zoom/game-zoom');
var GameMinimap = /*#__PURE__*/function () {
  function GameMinimap(app, mod) {
    _classCallCheck(this, GameMinimap);
    this.app = app;
    this.mod = mod;
    this.enable_zoom = 0;
    this.zoom = null;
    this.dragging = false;
    this.dragged = false;
    this.drag_x = 0;
    this.drag_y = 0;
    this.drag_start_x = 0;
    this.drag_start_y = 0;
    this.moving = false;
    this.move_x = 0;
    this.move_y = 0;
    this.move_start_x = 0;
    this.move_start_y = 0;
    this.markers = {};
    this.redraw_markers = true;
    this.minimap_el = null;
    this.board_el = null;
    this.viewport_el = null;
    this.markers_el = null;
    this.clone_el = null;
    this.restore_el = null;
    this.minimized = false;
    this.floating = false;
    this.dock_parent = null;
    this.dock_next = null;
    this.dock_rect = null;
    this.saved_box = null;
    this.resizing = false;
    this.resize_right = 0;
    this.resize_bottom = 0;
    this.resize_ratio = 1;
    this.resize_start_x = 0;
    this.resize_start_y = 0;
    this.resize_start_width = 0;
    this.focus = null;
  }
  return _createClass(GameMinimap, [{
    key: "viewFrame",
    value: function viewFrame(b) {
      if (!b) {
        return {
          x: 0,
          y: 0,
          width: 1,
          height: 1
        };
      }
      var focus = this.focus;
      if (!focus || !(focus.width > 0) || !(focus.height > 0)) {
        return {
          x: 0,
          y: 0,
          width: b.width,
          height: b.height
        };
      }
      var width = Math.min(focus.width, b.width);
      var height = Math.min(focus.height, b.height);
      return {
        x: Math.max(0, Math.min(focus.x || 0, Math.max(0, b.width - width))),
        y: Math.max(0, Math.min(focus.y || 0, Math.max(0, b.height - height))),
        width: width,
        height: height
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      if (!this.mod.browser_active) {
        return;
      }
      var b = this.mod.getBoardState();
      if (!b) {
        return;
      }
      if (!this.minimap_el) {
        this.app.browser.addStylesheet('/saito/css-imports/ui/game-minimap.css');
        this.app.browser.addElementToDom(GameMinimapTemplate());
        this.minimap_el = document.querySelector('.game-minimap');
        this.board_el = document.querySelector('.game-minimap .board');
        this.viewport_el = document.querySelector('.game-minimap .viewport');
        this.markers_el = document.querySelector('.game-minimap .markers');
        this.attachEvents();
      }
      this.ensureRestoreButton();
      if (this.minimized) {
        return;
      }
      if (this.enable_zoom && this.minimap_el) {
        if (!this.zoom) {
          this.zoom = new GameZoom(this.app, this.mod, this);
        }
        this.zoom.render(this.minimap_el);
        b = this.mod.getBoardState();
        if (!b) {
          return;
        }
      }
      if (!this.board_el || !this.viewport_el || !this.markers_el) {
        return;
      }
      var frame = this.viewFrame(b);
      var ratio = "".concat(frame.width, " / ").concat(frame.height);
      if (this.board_el.style.aspectRatio !== ratio) {
        this.board_el.style.aspectRatio = ratio;
        if (!this.aspect_wait) {
          this.aspect_wait = true;
          requestAnimationFrame(function () {
            _this.aspect_wait = false;
            _this.render();
          });
        }
        return;
      }
      if (b.image && !this.board_el.style.backgroundImage) {
        this.board_el.style.backgroundImage = "url(\"".concat(b.image, "\")");
      }
      this.applyBackdrop(b);
      var map = this.board_el.getBoundingClientRect();
      if (this.focus && b.image && map.width) {
        var bg_scale = (this.board_el.clientWidth || map.width) / frame.width;
        this.board_el.style.backgroundRepeat = 'no-repeat';
        this.board_el.style.backgroundSize = "".concat(b.width * bg_scale, "px ").concat(b.height * bg_scale, "px");
        this.board_el.style.backgroundPosition = "".concat(-frame.x * bg_scale, "px ").concat(-frame.y * bg_scale, "px");
      }
      if (!b.image) {
        this.syncClone(b, map, frame);
      }
      var vis_x = -b.x / b.scale;
      var vis_y = -b.y / b.scale;
      var vis_right = vis_x + window.innerWidth / b.scale;
      var vis_bottom = vis_y + window.innerHeight / b.scale;
      vis_x = Math.max(frame.x, Math.min(vis_x, frame.x + frame.width));
      vis_y = Math.max(frame.y, Math.min(vis_y, frame.y + frame.height));
      vis_right = Math.max(frame.x, Math.min(vis_right, frame.x + frame.width));
      vis_bottom = Math.max(frame.y, Math.min(vis_bottom, frame.y + frame.height));
      this.viewport_el.style.left = (vis_x - frame.x) / frame.width * map.width + 'px';
      this.viewport_el.style.top = (vis_y - frame.y) / frame.height * map.height + 'px';
      this.viewport_el.style.width = (vis_right - vis_x) / frame.width * map.width + 'px';
      this.viewport_el.style.height = (vis_bottom - vis_y) / frame.height * map.height + 'px';
      if (this.redraw_markers) {
        if (!map.width) {
          return;
        }
        this.markers_el.innerHTML = '';
        for (var id in this.markers) {
          var obj = this.markers[id];
          var el = document.createElement('div');
          el.className = 'circle';
          if (obj.type) {
            el.classList.add(obj.type);
          }
          if (obj.flash) {
            el.classList.add('flash');
          }
          el.style.background = obj.color;
          el.style.width = obj.size + 'px';
          el.style.height = obj.size + 'px';
          el.style.left = (obj.x * b.width - frame.x) / frame.width * map.width - obj.size / 2 + 'px';
          el.style.top = (obj.y * b.height - frame.y) / frame.height * map.height - obj.size / 2 + 'px';
          this.markers_el.appendChild(el);
        }
        this.redraw_markers = false;
      }
    }
  }, {
    key: "syncClone",
    value: function syncClone(b, map, frame) {
      if (!b.el || !this.board_el || !map.width) {
        return;
      }
      if (!this.dragging && !this.moving && !this.resizing) {
        if (this.clone_el) {
          this.clone_el.remove();
        }
        this.clone_el = b.el.cloneNode(true);
        this.clone_el.removeAttribute('id');
        // Keep `gameboard` so module CSS still paints the clone (Twilight/Paths/HIS
        // map image, Imperium hex layout). `game-minimap-clone` marks it so live-board
        // lookups (getBoardElement) never treat this copy as the board on the table.
        this.clone_el.classList.remove('gameboard-clone');
        this.clone_el.classList.add('game-minimap-clone');
        this.clone_el.querySelectorAll('[id]').forEach(function (el) {
          el.id = 'minimap-' + el.id;
        });
        this.clone_el.style.position = 'absolute';
        this.clone_el.style.top = '0px';
        this.clone_el.style.left = '0px';
        this.clone_el.style.right = 'auto';
        this.clone_el.style.bottom = 'auto';
        this.clone_el.style.margin = '0px';
        this.clone_el.style.transformOrigin = 'top left';
        this.clone_el.style.pointerEvents = 'none';
        this.board_el.insertBefore(this.clone_el, this.board_el.firstChild);
      }
      if (this.clone_el && b.width) {
        var view = frame || this.viewFrame(b);
        var scale = map.width / view.width;
        this.clone_el.style.width = b.width + 'px';
        this.clone_el.style.height = b.height + 'px';
        this.clone_el.style.transform = "scale(".concat(scale, ") translate(").concat(-view.x, "px, ").concat(-view.y, "px)");
      }
    }
  }, {
    key: "snapshot",
    value: function snapshot() {
      var _this2 = this;
      if (!this.mod.browser_active || this.minimized) {
        return;
      }
      if (!this.minimap_el) {
        this.render();
      }
      if (!this.board_el) {
        return;
      }
      var b = this.mod.getBoardState();
      if (!b) {
        return;
      }
      var map = this.board_el.getBoundingClientRect();
      if (!map.width) {
        if (!this.snapshot_wait) {
          this.snapshot_wait = true;
          requestAnimationFrame(function () {
            _this2.snapshot_wait = false;
            _this2.snapshot();
          });
        }
        return;
      }
      this.board_el.style.backgroundImage = 'none';
      this.syncClone(b, map, this.viewFrame(b));
      this.applyBackdrop(b);
    }
  }, {
    key: "applyBackdrop",
    value: function applyBackdrop(b) {
      if (!this.board_el || !b || b.image) {
        return;
      }
      var backdrop = '';
      if (typeof this.mod.getBoardBackdrop === 'function') {
        backdrop = this.mod.getBoardBackdrop() || '';
      }
      if (!backdrop) {
        return;
      }
      this.board_el.style.backgroundImage = "url(\"".concat(backdrop, "\")");
      this.board_el.style.backgroundSize = 'cover';
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var minimap = this.minimap_el;
      var board = this.board_el;
      var viewport = this.viewport_el;
      if (minimap) {
        minimap.addEventListener('mouseenter', function () {
          if (_this3.zoom) {
            _this3.zoom.show();
          }
        });
        minimap.addEventListener('mouseleave', function () {
          if (_this3.zoom) {
            _this3.zoom.hide();
          }
        });
        var close_el = minimap.querySelector('.game-minimap-close');
        if (close_el) {
          close_el.addEventListener('mousedown', function (e) {
            e.stopPropagation();
          });
          close_el.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this3.minimize();
          });
        }
        var resize_el = minimap.querySelector('.game-minimap-resize');
        if (resize_el) {
          resize_el.addEventListener('mousedown', function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this3.beginResize(e);
          });
        }
        minimap.addEventListener('mousedown', function (e) {
          e.stopPropagation();
          if (e.target.closest('.viewport') || e.target.closest('.game-zoom') || e.target.closest('.game-minimap-close') || e.target.closest('.game-minimap-resize')) {
            return;
          }
          _this3.moving = true;
          _this3.dragged = false;
          var box = minimap.getBoundingClientRect();
          _this3.move_x = e.clientX - box.left;
          _this3.move_y = e.clientY - box.top;
          _this3.move_start_x = e.clientX;
          _this3.move_start_y = e.clientY;
        });
        minimap.addEventListener('click', function (e) {
          e.stopPropagation();
          if (e.target.closest('.game-minimap-close') || e.target.closest('.game-minimap-resize')) {
            return;
          }
          if (_this3.zoom && !_this3.dragged) {
            _this3.zoom.interacted = true;
            _this3.zoom.show();
          }
        });
      }
      if (board) {
        board.addEventListener('click', function (e) {
          _this3.onClick(e);
        });
      }
      if (viewport) {
        viewport.addEventListener('click', function (e) {
          e.stopPropagation();
        });
        viewport.addEventListener('mousedown', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this3.dragged = false;
          var board_box = board ? board.getBoundingClientRect() : null;
          var view_box = viewport.getBoundingClientRect();
          var covers_map = board_box && view_box.width >= board_box.width - 1 && view_box.height >= board_box.height - 1;
          if (covers_map && minimap) {
            _this3.moving = true;
            var _box = minimap.getBoundingClientRect();
            _this3.move_x = e.clientX - _box.left;
            _this3.move_y = e.clientY - _box.top;
            _this3.move_start_x = e.clientX;
            _this3.move_start_y = e.clientY;
            return;
          }
          _this3.dragging = true;
          var box = viewport.getBoundingClientRect();
          _this3.drag_x = e.clientX - box.left;
          _this3.drag_y = e.clientY - box.top;
          _this3.drag_start_x = e.clientX;
          _this3.drag_start_y = e.clientY;
        });
      }
      document.addEventListener('mousemove', function (e) {
        if (_this3.resizing) {
          _this3.onResize(e);
          return;
        }
        if (_this3.moving) {
          _this3.onDrag(e);
          return;
        }
        if (!_this3.dragging) {
          return;
        }
        if (Math.abs(e.clientX - _this3.drag_start_x) > 4 || Math.abs(e.clientY - _this3.drag_start_y) > 4) {
          _this3.dragged = true;
        }
        if (!_this3.dragged) {
          return;
        }
        var b = _this3.mod.getBoardState();
        if (!b || !_this3.board_el) {
          return;
        }
        var box = _this3.board_el.getBoundingClientRect();
        var frame = _this3.viewFrame(b);
        var view_w = window.innerWidth / b.scale;
        var view_h = window.innerHeight / b.scale;
        var vis_x = frame.x + (e.clientX - box.left - _this3.drag_x) / box.width * frame.width;
        var vis_y = frame.y + (e.clientY - box.top - _this3.drag_y) / box.height * frame.height;
        vis_x = Math.max(frame.x, Math.min(vis_x, frame.x + Math.max(0, frame.width - view_w)));
        vis_y = Math.max(frame.y, Math.min(vis_y, frame.y + Math.max(0, frame.height - view_h)));
        _this3.mod.setBoardPosition(-vis_x * b.scale, -vis_y * b.scale);
        _this3.render();
      });
      document.addEventListener('mouseup', function (e) {
        if (!_this3.dragging && !_this3.moving && !_this3.resizing) {
          return;
        }
        if (!_this3.dragged) {
          if (!_this3.resizing && (!e.target.closest || !e.target.closest('.game-zoom'))) {
            _this3.onClick(e);
          }
        } else {
          var _swallow = function swallow(ev) {
            ev.stopPropagation();
            ev.preventDefault();
            document.removeEventListener('click', _swallow, true);
          };
          document.addEventListener('click', _swallow, true);
        }
        if (_this3.moving && _this3.floating) {
          _this3.maybeRedock(e);
        }
        _this3.dragging = false;
        _this3.moving = false;
        _this3.resizing = false;
        _this3.dragged = false;
        if (_this3.minimap_el) {
          _this3.minimap_el.classList.remove('resizing');
        }
      });
      var el = this.mod.getBoardElement();
      if (el) {
        if (typeof $ !== 'undefined') {
          $(el).on('drag dragstop', function () {
            _this3.render();
          });
        }
        el.addEventListener('wheel', function () {
          _this3.render();
        });
      }
      var scaler = document.querySelector('#game_board_sizer input');
      if (scaler) {
        scaler.addEventListener('input', function () {
          _this3.render();
        });
      }
      document.querySelectorAll('#game_board_sizer button').forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.render();
        });
      });
      window.addEventListener('resize', function () {
        _this3.redraw_markers = true;
        _this3.render();
      });
    }
  }, {
    key: "ensureRestoreButton",
    value: function ensureRestoreButton() {
      var _this4 = this;
      if (this.restore_el && document.body.contains(this.restore_el)) {
        return;
      }
      var restore_el = document.getElementById('game-minimap-restore');
      if (!restore_el) {
        var hamburger = document.querySelector('#saito-header .hamburger-container');
        if (!hamburger) {
          return;
        }
        hamburger.insertAdjacentHTML('afterbegin', GameMinimapTemplate.restoreButton());
        restore_el = document.getElementById('game-minimap-restore');
      }
      if (!restore_el) {
        return;
      }
      this.restore_el = restore_el;
      if (!this.restore_el.dataset.bound) {
        this.restore_el.dataset.bound = '1';
        this.restore_el.addEventListener('click', function (e) {
          e.stopPropagation();
          _this4.restore();
        });
      }
    }
  }, {
    key: "minimize",
    value: function minimize() {
      if (!this.minimap_el || this.minimized) {
        return;
      }
      var box = this.minimap_el.getBoundingClientRect();
      this.saved_box = {
        left: box.left,
        top: box.top,
        width: box.width,
        height: box.height
      };
      this.minimized = true;
      this.moving = false;
      this.dragging = false;
      this.resizing = false;
      this.minimap_el.classList.add('minimized');
      if (this.zoom) {
        this.zoom.hide();
      }
      this.ensureRestoreButton();
      if (this.restore_el) {
        this.restore_el.classList.add('visible');
      }
    }
  }, {
    key: "restore",
    value: function restore() {
      if (!this.minimap_el || !this.minimized) {
        return;
      }
      if (this.saved_box) {
        this.minimap_el.style.left = this.saved_box.left + 'px';
        this.minimap_el.style.top = this.saved_box.top + 'px';
        this.minimap_el.style.width = this.saved_box.width + 'px';
        this.minimap_el.style.height = this.saved_box.height + 'px';
        this.minimap_el.style.right = 'auto';
        this.minimap_el.style.bottom = 'auto';
      }
      this.minimized = false;
      this.minimap_el.classList.remove('minimized');
      if (this.restore_el) {
        this.restore_el.classList.remove('visible');
      }
      this.redraw_markers = true;
      this.render();
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var b = this.mod.getBoardState();
      if (!b || !this.board_el) {
        return;
      }
      var box = this.board_el.getBoundingClientRect();
      var frame = this.viewFrame(b);
      var board_x = frame.x + (e.clientX - box.left) / box.width * frame.width;
      var board_y = frame.y + (e.clientY - box.top) / box.height * frame.height;
      var view_w = window.innerWidth / b.scale;
      var view_h = window.innerHeight / b.scale;
      var vis_x = board_x - view_w / 2;
      var vis_y = board_y - view_h / 2;
      vis_x = Math.max(0, Math.min(vis_x, Math.max(0, b.width - view_w)));
      vis_y = Math.max(0, Math.min(vis_y, Math.max(0, b.height - view_h)));
      this.mod.setBoardPosition(-vis_x * b.scale, -vis_y * b.scale);
      this.render();
    }
  }, {
    key: "beginResize",
    value: function beginResize(e) {
      if (!this.minimap_el || !this.board_el || this.minimized) {
        return;
      }
      var board = this.board_el.getBoundingClientRect();
      if (!board.width || !board.height) {
        return;
      }
      this.resizing = true;
      this.moving = false;
      this.dragging = false;
      this.dragged = false;
      this.resize_right = board.right;
      this.resize_bottom = board.bottom;
      this.resize_ratio = board.height / board.width;
      this.resize_start_x = e.clientX;
      this.resize_start_y = e.clientY;
      this.resize_start_width = board.width;
      this.minimap_el.classList.add('resizing');
    }
  }, {
    key: "onResize",
    value: function onResize(e) {
      if (!this.resizing || !this.minimap_el) {
        return;
      }
      if (Math.abs(e.clientX - this.resize_start_x) > 4 || Math.abs(e.clientY - this.resize_start_y) > 4) {
        this.dragged = true;
      }
      if (!this.dragged) {
        return;
      }
      var dw = this.resize_start_x - e.clientX;
      var dh = this.resize_start_y - e.clientY;
      var width = this.resize_start_width + (dw + dh / this.resize_ratio) / 2;
      var min_width = 140;
      var max_width = Math.min(window.innerWidth * 0.7, this.resize_right, this.resize_bottom / this.resize_ratio);
      width = Math.max(min_width, Math.min(width, max_width));
      var height = width * this.resize_ratio;
      this.minimap_el.style.width = width + 'px';
      this.minimap_el.style.height = 'auto';
      this.minimap_el.style.left = this.resize_right - width + 'px';
      this.minimap_el.style.top = this.resize_bottom - height + 'px';
      this.minimap_el.style.right = 'auto';
      this.minimap_el.style.bottom = 'auto';
      this.redraw_markers = true;
      this.render();
    }
  }, {
    key: "onDrag",
    value: function onDrag(e) {
      if (this.dragging || !this.moving) {
        return;
      }
      if (Math.abs(e.clientX - this.move_start_x) > 4 || Math.abs(e.clientY - this.move_start_y) > 4) {
        this.dragged = true;
      }
      if (!this.dragged || !this.minimap_el) {
        return;
      }
      this.liftFromDock();
      var box = this.minimap_el.getBoundingClientRect();
      var left = e.clientX - this.move_x;
      var top = e.clientY - this.move_y;
      var visible = 36;
      left = Math.max(visible - box.width, Math.min(left, window.innerWidth - visible));
      top = Math.max(visible - box.height, Math.min(top, window.innerHeight - visible));
      this.minimap_el.style.left = left + 'px';
      this.minimap_el.style.top = top + 'px';
      this.minimap_el.style.right = 'auto';
      this.minimap_el.style.bottom = 'auto';
    }
  }, {
    key: "liftFromDock",
    value: function liftFromDock() {
      var el = this.minimap_el;
      if (!el || this.floating) {
        return;
      }
      var positioned = window.getComputedStyle(el).position;
      if (positioned === 'fixed' || positioned === 'absolute') {
        return;
      }
      var box = el.getBoundingClientRect();
      this.dock_parent = el.parentElement;
      this.dock_next = el.nextSibling;
      this.dock_rect = {
        left: box.left,
        top: box.top,
        width: box.width,
        height: box.height
      };
      document.body.appendChild(el);
      el.classList.add('is-floating');
      el.style.position = 'fixed';
      el.style.left = box.left + 'px';
      el.style.top = box.top + 'px';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
      el.style.width = box.width + 'px';
      el.style.height = 'auto';
      el.style.margin = '0';
      el.style.zIndex = '80';
      this.floating = true;
    }
  }, {
    key: "maybeRedock",
    value: function maybeRedock(e) {
      if (!this.floating || !this.minimap_el || !this.dock_parent || !this.dock_rect) {
        return;
      }
      if (!document.body.contains(this.dock_parent)) {
        return;
      }
      var slot = this.dock_rect;
      var pad = 24;
      var pointer_in_slot = e.clientX >= slot.left - pad && e.clientX <= slot.left + slot.width + pad && e.clientY >= slot.top - pad && e.clientY <= slot.top + slot.height + pad;
      var box = this.minimap_el.getBoundingClientRect();
      var cx = box.left + box.width / 2;
      var cy = box.top + box.height / 2;
      var center_in_slot = cx >= slot.left && cx <= slot.left + slot.width && cy >= slot.top && cy <= slot.top + slot.height;
      if (pointer_in_slot || center_in_slot) {
        this.redock();
      }
    }
  }, {
    key: "redock",
    value: function redock() {
      var el = this.minimap_el;
      if (!el || !this.dock_parent) {
        return;
      }
      if (this.dock_next && this.dock_next.parentElement === this.dock_parent) {
        this.dock_parent.insertBefore(el, this.dock_next);
      } else {
        this.dock_parent.prepend(el);
      }
      el.classList.remove('is-floating');
      el.style.position = '';
      el.style.left = '';
      el.style.top = '';
      el.style.right = '';
      el.style.bottom = '';
      el.style.width = '';
      el.style.height = '';
      el.style.margin = '';
      el.style.zIndex = '';
      this.floating = false;
      this.dock_parent = null;
      this.dock_next = null;
      this.dock_rect = null;
      this.redraw_markers = true;
      this.render();
    }
  }, {
    key: "add",
    value: function add(id, obj) {
      this.markers[id] = obj;
      this.redraw_markers = true;
      this.render();
    }
  }, {
    key: "remove",
    value: function remove(id) {
      delete this.markers[id];
      this.redraw_markers = true;
      this.render();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.markers = {};
      this.redraw_markers = true;
      this.render();
    }
  }]);
}();
module.exports = GameMinimap;